import React from 'react';
import SmePortal from './SmePortal';

const SmePortalContainer = () => {
  return <SmePortal />;
};

export default React.memo(SmePortalContainer);
